export const ChangePasswordPage = (destinationLang) => {
  return [
    {
      FormKey: "general-public-change-password",
      Key: "تغيير رمز",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "change-password-input-current-password",
      Key: "رمز فعلي",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "change-password-input-new-password",
      Key: "رمز جديد",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "change-password-btn-change-password",
      Key: "تغيير رمز",
      DistinitationLanguage: destinationLang,
    },
  ];
};
